import template from '../templates/global-menu-support.tpl.html';
import { DEFAULT_SUPPORT_LINKS } from './defaults';

// Bundle SVG Icons
import caretIcon from '../assets/images/icons/caret-down.svg';
import questionIcon from '../assets/images/icons/question-circle.svg';

let sharedInstance = null;

export default class GlobalSupportMenu {

  constructor(container, options) {
    if (!sharedInstance) {
      sharedInstance = this;
    }

    this.caretIcon = caretIcon;
    this.questionIcon = questionIcon;

    this.container = container;
    this.options = options;

    this.render();
    this.observe();

    return sharedInstance;
  }

  render() {
    const parser = new DOMParser();
    const renderedTemplate = template(this);
    const parsedTemplate = parser.parseFromString(renderedTemplate, 'text/html');

    this.container.innerHTML = ''; // Clear the container...
    this.container.appendChild(parsedTemplate.body.firstElementChild);

    this.menuElement = this.container.querySelector('.items-container');
    this.buttonElement = this.container.querySelector('.dt-gnm-menu-support-button');
  }

  observe() {
    this._clickListener = this.onClick.bind(this);
    this.buttonElement.addEventListener('click', this._clickListener);
  }

  destroy() {
    this.buttonElement.removeEventListener('click', this._clickListener);
    this._clickListener = null;
  }

  open() {
    this.menuElement.removeAttribute('hidden');
    this.buttonElement.classList.add('open');
    if (!this._documentClickListener) {
      this._documentClickListener = this.onDocumentClick.bind(this);
      document.addEventListener('click', this._documentClickListener);
    }
  }

  close() {
    this.menuElement.setAttribute('hidden', true);
    this.buttonElement.classList.remove('open');
    if (this._documentClickListener) {
      document.removeEventListener('click', this._documentClickListener);
      this._documentClickListener = null;
    }
  }

  onClick() {
    if (this.isHidden) {
      this.open();
    } else {
      this.close();
    }
  }

  onDocumentClick(event) {
    if (!this.container.contains(event.target)) {
      this.close();
    }
  }

  get isHidden() {
    return this.menuElement.hasAttribute('hidden');
  }

  get createTicketUrl() {
    return this.options.createTicketUrl || DEFAULT_SUPPORT_LINKS['createTicketUrl'];
  }

  get supportCenterUrl() {
    return this.options.supportCenterUrl || DEFAULT_SUPPORT_LINKS['supportCenterUrl'];
  }

  get knowledgeBaseUrl() {
    return this.options.knowledgeBaseUrl || DEFAULT_SUPPORT_LINKS['knowledgeBaseUrl'];
  }

  get feedbackUrl() {
    return this.options.feedbackUrl || DEFAULT_SUPPORT_LINKS['feedbackUrl'];
  }

  get statusUrl() {
    return this.options.statusUrl || DEFAULT_SUPPORT_LINKS['statusUrl'];
  }

  get phoneNumber() {
    return this.options.phoneNumber;
  }

  get phoneUrl() {
    return `tel:${this.options.phoneNumber.replace(/[^0-9+]/g, '')}`;
  }

  get chatUrl() {
    return this.options.chatUrl;
  }

}



// WEBPACK FOOTER //
// ./src/scripts/global-menu-support.js